import { DataWizardAct, ParentVM } from 'civil-status/view-models/step-form';
import { CodeSubject } from 'civil-status/constants/code-subject-section';
import { ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';
import { DateTime } from 'luxon';
import {
  ID_CHOOSING_SURNAME,
  VALUES_CHOOSING_SURNAME,
} from 'civil-status/components/step/form/last-step/accordions/subject/form/list/list-reason-choosing-surname';
import { ID_ALTRO_STATO, LABEL_ALTRO_STATO } from 'shell/components/shared/foreign-state-list';
import { ID_ALTRO_COMUNE, LABEL_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { IdResidence } from 'civil-status/constants/id-residence';
import { CodeTypeAct } from 'civil-status/constants/code-type-act';

export const transformSubjects = (data: DataWizardAct): Record<string, ParentVM> | undefined => {
  const castedResponseSoggetti = data?.soggettoList || [];
  const castedResponseDatiNascita = data.datiNascita || {};
  const castedResponseDatiDichiarante = data.datiDichiarante || {};
  const castedResponseEvento = data.evento || {};
  const castedResponseStatoCivile = data.statoCivile || {};
  const castedResponseDatiEventoCittadinanza = data.datiEventoCittadinanza || {};
  const castedResponseAscendente = data.ascendente || {};
  const castedResponseUnioneCivileAtti = data.unioneCivileAtti || {};
  const castedResponseMatrimonioAtti = data.matrimonioAtti || {};
  const castedResponseScioglimentoUnioneCivileAtti = data.scioglimentoUnioneCivileAtti || {};
  const castedResponseSeperazione = data.separazione || {};
  const castedResponseNegoziazioneAssistita = data.negoziazioneAssistita || {};
  const castedResponseDatiEventoRiconoscimento = data.datiEventoRiconoscimento || {};
  const castedResponseTrascrizioneCittadinanza = data.trascrizioneCittadinanza || {};
  const castedResponseFiglioList = data.figlioList || [];
  const castedResponseDatiMorte = data.datiMorte || {};

  if (castedResponseSoggetti?.length === 0) {
    return undefined;
  }

  // se l'atto proviene da ICARO
  const isFromIcaro = Boolean(castedResponseStatoCivile.idIcaro);

  const res: Record<string, ParentVM> = {};

  castedResponseSoggetti.forEach((itemSubject) => {
    const keySubject = `subject-${itemSubject?.codiceSoggetto}`;

    const currentFiglio = castedResponseFiglioList.find(
      (el) => el.codiceSoggetto === itemSubject?.codiceSoggetto
    );

    const isBornForeign = itemSubject?.idStatoNascita
      ? itemSubject?.idStatoNascita !== ID_ITALIAN_NATION
      : false;
    const isBornItalian = itemSubject?.idStatoNascita
      ? itemSubject?.idStatoNascita === ID_ITALIAN_NATION
      : false;

    const isResidenceForeign = itemSubject?.idStatoResidenza
      ? itemSubject?.idStatoResidenza && itemSubject?.idStatoResidenza !== ID_ITALIAN_NATION
      : false;
    const isResidenceItalian = itemSubject?.idStatoResidenza
      ? itemSubject?.idStatoResidenza && itemSubject?.idStatoResidenza === ID_ITALIAN_NATION
      : false;

    const isOtherState = itemSubject?.idStatoNascita?.toString() === ID_ALTRO_STATO;
    const isOtherMunicipality = itemSubject?.idComuneNascita?.toString() === ID_ALTRO_COMUNE;

    const isOtherStateResidence = itemSubject?.idStatoResidenza?.toString() === ID_ALTRO_STATO;
    const isOtherMunicipalityResidence =
      itemSubject?.idComuneResidenza?.toString() === ID_ALTRO_COMUNE;

    const isDataBorn =
      itemSubject?.codiceSoggetto === CodeSubject.INT_NAS ||
      itemSubject?.codiceSoggetto === CodeSubject.INT_NAS2 ||
      itemSubject?.codiceSoggetto === CodeSubject.INT_NAS2_C1;

    res[keySubject] = {
      isSaved: true,
      codeSubject: itemSubject?.codiceSoggetto || '',
      // se viene da ICARO e non abbiamo l'id ANSC inizializzare i dati della ricerca
      searchPerson:
        isFromIcaro && !itemSubject?.idSoggettoAnsc
          ? {
              fiscalCode: itemSubject?.codiceFiscale || '',
              surname: itemSubject?.cognome || '',
              withoutSurname: !Boolean(itemSubject?.cognome),
              name: itemSubject?.nome || '',
              withoutName: !Boolean(itemSubject?.nome),
              gender: itemSubject?.sesso || '',
              birthdayDate: itemSubject?.dataNascita
                ? DateTime.fromISO(itemSubject?.dataNascita)
                : null,
              birthdayDateChoice: itemSubject?.dataNascita ? ['day', 'month', 'year'] : undefined,
            }
          : undefined,
      generality: {
        idSubject: itemSubject?.key?.idSoggetto || '',
        idAnpr: itemSubject?.idSoggettoAnpr || '',
        idAnsc: itemSubject?.idSoggettoAnsc || '',
        idNationalIdentifier: itemSubject?.idAnpr || '',
        fiscalCode: itemSubject?.codiceFiscale || '',
        surname: itemSubject?.cognome || '',
        name: itemSubject?.nome || '',
        gender: itemSubject?.sesso || '',
        documentTypology: itemSubject?.tipoDocRiconoscimento || '',
        documentNumber: itemSubject?.numeroDocRiconoscimento || '',
        documentExpiryDate: itemSubject?.dataScadenzaDocRicon
          ? DateTime.fromISO(itemSubject?.dataScadenzaDocRicon)
          : null,
        documentReleaseFrom: itemSubject?.docRiconRilasciatoDa || '',
        documentReleaseDate: itemSubject?.dataRilascioDocRicon
          ? DateTime.fromISO(itemSubject?.dataRilascioDocRicon)
          : null,
        isSignatory: itemSubject.flagFirmatario === '1',
        isApolide:
          itemSubject?.codiceSoggetto === CodeSubject.INTEST &&
          castedResponseDatiEventoCittadinanza.flagIntestatarioApolide === '1',
        dateStartResidence:
          itemSubject?.codiceSoggetto === CodeSubject.INTEST &&
          castedResponseDatiEventoCittadinanza.dataInizioResidenza
            ? DateTime.fromISO(castedResponseDatiEventoCittadinanza.dataInizioResidenza)
            : null,
        otherCitizenship:
          itemSubject?.codiceSoggetto === CodeSubject.INTEST &&
          castedResponseTrascrizioneCittadinanza.nomeUlterioreCittadinanza
            ? {
                id: castedResponseTrascrizioneCittadinanza.ulterioreCittadinanza?.toString(),
                idAnpr: castedResponseTrascrizioneCittadinanza.ulterioreCittadinanza,
                value: castedResponseTrascrizioneCittadinanza.nomeUlterioreCittadinanza,
              }
            : undefined,
        reasonLossCitizenship:
          itemSubject?.codiceSoggetto === CodeSubject.INTEST &&
          castedResponseDatiEventoCittadinanza.tipoPerditaPerMatrimonio
            ? {
                id: castedResponseDatiEventoCittadinanza.tipoPerditaPerMatrimonio,
                value: castedResponseDatiEventoCittadinanza.testoMotivoPerditaCittadinanza || '',
              }
            : undefined,
        reasonDelay:
          isDataBorn && castedResponseEvento.noteRitardo ? castedResponseEvento.noteRitardo : '',
        codeIstat:
          isDataBorn && castedResponseStatoCivile.nascitaIstat
            ? { id: castedResponseStatoCivile.nascitaIstat, value: '' }
            : undefined,
        residenceId:
          isDataBorn && castedResponseStatoCivile.tipoResidenzaNascituro
            ? castedResponseStatoCivile.tipoResidenzaNascituro
            : undefined,
        birthPlaceItem:
          isDataBorn && castedResponseStatoCivile.luogoEvento
            ? { id: castedResponseStatoCivile.luogoEvento, value: '' }
            : undefined,
        isWithInterprete:
          itemSubject?.flagDichiarante === '1' &&
          castedResponseEvento.flagAusilioInterprete === '1',
        rolo:
          itemSubject?.flagDichiarante === '1' && castedResponseDatiDichiarante
            ? castedResponseDatiDichiarante.titoloDichiarante
            : '',
        roloSecretary:
          itemSubject.codiceSoggetto === CodeSubject.SEGRCOM_UNI_CIV
            ? castedResponseUnioneCivileAtti.tipoRuoloSegretario
            : itemSubject.codiceSoggetto === CodeSubject.SEGRCOM_MATR
            ? castedResponseMatrimonioAtti.tipoRuoloSegretario
            : '',
        attorney:
          itemSubject?.codiceSoggetto === CodeSubject.PROC_MA ||
          itemSubject?.codiceSoggetto === CodeSubject.PROC_PA
            ? castedResponseDatiDichiarante.datiEssenzialiProcura
            : undefined,
        conditionsItem:
          itemSubject?.flagDichiarante === '1'
            ? itemSubject?.codiceSoggetto === CodeSubject.UNICIV1
              ? {
                  id: castedResponseUnioneCivileAtti.tipoComprensioneConiuge1 || '0',
                  value: '',
                }
              : itemSubject?.codiceSoggetto === CodeSubject.UNICIV2
              ? {
                  id: castedResponseUnioneCivileAtti.tipoComprensioneConiuge2 || '0',
                  value: '',
                }
              : itemSubject?.codiceSoggetto === CodeSubject.UNICIV1_SCIO
              ? {
                  id: castedResponseScioglimentoUnioneCivileAtti.tipoComprensioneConiuge1 || '0',
                  value: '',
                }
              : itemSubject?.codiceSoggetto === CodeSubject.UNICIV2_SCIO
              ? {
                  id: castedResponseScioglimentoUnioneCivileAtti.tipoComprensioneConiuge2 || '0',
                  value: '',
                }
              : itemSubject.codiceSoggetto === CodeSubject.SPOSO
              ? {
                  id: castedResponseMatrimonioAtti.tipoComprensioneSposo || '0',
                  value: '',
                }
              : itemSubject.codiceSoggetto === CodeSubject.SPOSA
              ? {
                  id: castedResponseMatrimonioAtti.tipoComprensioneSposa || '0',
                  value: '',
                }
              : {
                  id: castedResponseDatiDichiarante.comprensione || '0',
                  value: '',
                }
            : undefined,
        reasonImpediment:
          itemSubject?.flagDichiarante === '1'
            ? itemSubject?.codiceSoggetto === CodeSubject.UNICIV1
              ? castedResponseUnioneCivileAtti.descrizioneImpedimentoScritturaConiuge1 || ''
              : itemSubject?.codiceSoggetto === CodeSubject.UNICIV2
              ? castedResponseUnioneCivileAtti.descrizioneImpedimentoScritturaConiuge2 || ''
              : itemSubject?.codiceSoggetto === CodeSubject.UNICIV1_SCIO
              ? castedResponseScioglimentoUnioneCivileAtti.descrizioneImpedimScrittConiuge1 || ''
              : itemSubject?.codiceSoggetto === CodeSubject.UNICIV2_SCIO
              ? castedResponseScioglimentoUnioneCivileAtti.descrizioneImpedimScrittConiuge2 || ''
              : itemSubject?.codiceSoggetto === CodeSubject.SPOSO
              ? castedResponseMatrimonioAtti.descrizioneImpedimScritturaSposo
              : itemSubject?.codiceSoggetto === CodeSubject.SPOSA
              ? castedResponseMatrimonioAtti.descrizioneImpedimScritturaSposa
              : castedResponseDatiDichiarante.motivoImpedimento || ''
            : undefined,
        conditionsItemSignatory: itemSubject.impedimento
          ? { id: itemSubject.impedimento || '', value: '' }
          : undefined,
        isImminentDangerOfLife:
          itemSubject?.codiceSoggetto === CodeSubject.UNICIV1 ||
          itemSubject?.codiceSoggetto === CodeSubject.UNICIV1_SCIO
            ? castedResponseUnioneCivileAtti.flagConiuge1InPericoloVita === '1'
            : itemSubject?.codiceSoggetto === CodeSubject.UNICIV2 ||
              itemSubject?.codiceSoggetto === CodeSubject.UNICIV2_SCIO
            ? castedResponseUnioneCivileAtti.flagConiuge2InPericoloVita === '1'
            : itemSubject?.codiceSoggetto === CodeSubject.SPOSO
            ? castedResponseMatrimonioAtti.flagSposoInPericoloVita === '1'
            : itemSubject?.codiceSoggetto === CodeSubject.SPOSA
            ? castedResponseMatrimonioAtti.flagSposaInPericoloVita === '1'
            : false,
        verificationOfWill:
          itemSubject?.codiceSoggetto === CodeSubject.UNICIV1 ||
          itemSubject?.codiceSoggetto === CodeSubject.UNICIV1_SCIO
            ? castedResponseUnioneCivileAtti.descrizioneAccertamentoVolontaConiuge1 || ''
            : itemSubject?.codiceSoggetto === CodeSubject.UNICIV2 ||
              itemSubject?.codiceSoggetto === CodeSubject.UNICIV2_SCIO
            ? castedResponseUnioneCivileAtti.descrizioneAccertamentoVolontaConiuge2 || ''
            : itemSubject?.codiceSoggetto === CodeSubject.SPOSO
            ? castedResponseMatrimonioAtti.descrizioneAccertamVolontaSposo
            : itemSubject?.codiceSoggetto === CodeSubject.SPOSA
            ? castedResponseMatrimonioAtti.descrizioneAccertamVolontaSposa
            : false,
        nationality: itemSubject?.codiceNazionalita
          ? {
              id: itemSubject?.codiceNazionalita || '',
              value: itemSubject?.descrizioneNazionalita || '',
              idAnpr: itemSubject?.codiceNazionalita || '',
            }
          : undefined,
        verificationTypeItem:
          isDataBorn && castedResponseDatiNascita.accertamento
            ? {
                id: castedResponseDatiNascita.accertamento || '',
                value: '',
              }
            : undefined,
        civilStatusItem: itemSubject?.tipoStatoCivile
          ? {
              id: itemSubject?.tipoStatoCivile,
              value: itemSubject?.descrizioneStatoCivile || '',
            }
          : undefined,
        dateDeath:
          itemSubject?.codiceSoggetto === CodeSubject.INT_ANN && castedResponseDatiMorte.dataMorte
            ? DateTime.fromISO(castedResponseDatiMorte.dataMorte)
            : null,
        birthDate: itemSubject?.dataNascita ? DateTime.fromISO(itemSubject?.dataNascita) : null,
        birthTime:
          isDataBorn &&
          (castedResponseDatiNascita.oraNascita || castedResponseDatiNascita.minutoNascita)
            ? DateTime.fromFormat(
                `${
                  castedResponseDatiNascita.oraNascita?.toString().length === 1
                    ? `0${castedResponseDatiNascita.oraNascita}`
                    : castedResponseDatiNascita.oraNascita || '00'
                }:${
                  castedResponseDatiNascita.minutoNascita?.toString().length === 1
                    ? `0${castedResponseDatiNascita.minutoNascita}`
                    : castedResponseDatiNascita.minutoNascita || '00'
                }`,
                'HH:mm'
              )
            : null,
        bornTypology: castedResponseDatiNascita?.nascitaSoggetto || '',
        surnameItem:
          isDataBorn && castedResponseDatiNascita.sceltaCognome
            ? {
                id: castedResponseDatiNascita.sceltaCognome || '',
                value: '',
              }
            : undefined,
        reasonChoosingSurname:
          castedResponseDatiNascita.precisazioneCognome === VALUES_CHOOSING_SURNAME.Art131
            ? {
                id: ID_CHOOSING_SURNAME.Art131,
                value: VALUES_CHOOSING_SURNAME.Art131,
              }
            : castedResponseDatiNascita.precisazioneCognome === VALUES_CHOOSING_SURNAME.Art218
            ? {
                id: ID_CHOOSING_SURNAME.Art218,
                value: VALUES_CHOOSING_SURNAME.Art218,
              }
            : castedResponseDatiNascita.precisazioneCognome
            ? {
                id: ID_CHOOSING_SURNAME.Altro,
                value: VALUES_CHOOSING_SURNAME.Altro,
              }
            : undefined,
        clarificationSurname: castedResponseDatiNascita.precisazioneCognome || '',
        descriptionBirthPlace:
          isDataBorn && castedResponseDatiNascita.luogoFiliazione
            ? castedResponseDatiNascita.luogoFiliazione
            : '',
        isWithTwins: castedResponseDatiNascita.flagPartoGemellare === '1',
        allTwins: castedResponseDatiNascita.numeroGemelli || undefined,
        currentTwin: castedResponseDatiNascita.progressivoGemello || undefined,
        necropsyDate:
          isDataBorn && castedResponseDatiNascita.dataAccertamentoNecroscopo
            ? DateTime.fromISO(castedResponseDatiNascita.dataAccertamentoNecroscopo)
            : null,
        isBookTwins: Boolean(castedResponseStatoCivile.idAnsc || data.idEventoGemelloSuccessivo),
        isForeignBorn: isBornForeign,
        foreign: isBornForeign
          ? {
              municipality: {
                description: itemSubject?.comuneNascita || '',
                id: itemSubject?.idComuneNascita || undefined,
                province: itemSubject?.siglaProvNascita || undefined,
              },
              state: {
                id: itemSubject?.idStatoNascita || undefined,
                value: isOtherState ? LABEL_ALTRO_STATO : itemSubject?.statoNascita || '',
                code: itemSubject?.idStatoNascita || undefined,
                istatCode: itemSubject?.idProvNascita || undefined,
              },
              otherState: isOtherState ? itemSubject?.statoNascita : '',
              locationForeignBirth: itemSubject.nomeLocalitaEsteraNascita || undefined,
            }
          : undefined,
        italian: isBornItalian
          ? {
              municipality: {
                description: isOtherMunicipality
                  ? LABEL_ALTRO_COMUNE
                  : itemSubject?.comuneNascita || '',
                id: itemSubject?.idComuneNascita,
                code: itemSubject?.idComuneNascita,
                idProvince: itemSubject?.idProvNascita,
                province: itemSubject?.siglaProvNascita,
              },
              otherMunicipality: isOtherMunicipality ? itemSubject?.comuneNascita : '',
            }
          : undefined,
        address: itemSubject?.indirizzoResidenza || '',
        typeResidence: isResidenceForeign
          ? IdResidence.Foreign
          : isResidenceItalian
          ? IdResidence.Italian
          : IdResidence.NotKnown,
        foreignResidence: isResidenceForeign
          ? {
              municipality: {
                province: itemSubject?.siglaProvResidenza || '',
                provinceCode: itemSubject?.idProvResidenza || '',
                id: itemSubject?.idComuneResidenza || '',
                description: itemSubject?.nomeComuneResidenza || '',
              },
              state: {
                id: itemSubject?.idStatoNascita || undefined,
                code: itemSubject?.idStatoResidenza || '',
                value: isOtherStateResidence
                  ? LABEL_ALTRO_STATO
                  : itemSubject?.nomeStatoResidenza || '',
              },
              municipalityAire: itemSubject.idComuneAire
                ? {
                    id: itemSubject.idComuneAire?.toString() || undefined,
                    code: itemSubject.idComuneAire,
                    description: itemSubject.nomeComuneAire || undefined,
                    idProvince: itemSubject.idProvinciaAire?.toString() || undefined,
                    province: itemSubject.siglaProvinciaAire,
                  }
                : undefined,
              otherState: isOtherStateResidence ? itemSubject?.nomeStatoResidenza : '',
            }
          : undefined,
        italianResidence: isResidenceItalian
          ? {
              municipality: {
                province: itemSubject?.siglaProvResidenza || '',
                idProvince: itemSubject?.idProvResidenza || '',
                id: itemSubject?.idComuneResidenza || '',
                code: itemSubject?.idComuneResidenza || '',
                description: isOtherMunicipalityResidence
                  ? LABEL_ALTRO_COMUNE
                  : itemSubject?.nomeComuneResidenza || '',
              },
              otherMunicipality: isOtherMunicipalityResidence
                ? itemSubject?.nomeComuneResidenza
                : '',
            }
          : undefined,
        isUntraceable: itemSubject.flagIrreperibile === '1',
        relationship:
          itemSubject?.codiceSoggetto === CodeSubject.ASCEN
            ? castedResponseAscendente.gradoParentela || ''
            : undefined,
        ufcDelegate:
          itemSubject?.codiceSoggetto === CodeSubject.OFFICIANTE_UNI_CIV
            ? castedResponseUnioneCivileAtti.tipoOfficiante
            : itemSubject?.codiceSoggetto === CodeSubject.OFFICIANTE_MATR
            ? castedResponseMatrimonioAtti.tipoOfficiante
            : itemSubject?.codiceSoggetto === CodeSubject.OFFICIANTE_TRAS
            ? castedResponseMatrimonioAtti.tyOfficianteTrasmisAtto || ''
            : itemSubject?.codiceSoggetto === CodeSubject.OFFICIANTE_CITT
            ? castedResponseDatiEventoCittadinanza.tipoOfficiante || ''
            : '',
        lawyerForum:
          itemSubject?.codiceSoggetto === CodeSubject.AVVOC5
            ? castedResponseSeperazione.nomeForoAvvUnico
            : itemSubject?.codiceSoggetto === CodeSubject.AVVOC2
            ? castedResponseSeperazione.nomeForoAvvConiuge2
            : itemSubject?.codiceSoggetto === CodeSubject.AVVOC1
            ? castedResponseSeperazione.nomeForoAvvConiuge1
            : itemSubject?.codiceSoggetto === CodeSubject.AVVOC3
            ? castedResponseNegoziazioneAssistita.foroAvvConiuge1
            : itemSubject?.codiceSoggetto === CodeSubject.AVVOC4
            ? castedResponseNegoziazioneAssistita.foroAvvConiuge2
            : itemSubject?.codiceSoggetto === CodeSubject.AVVOCUC1
            ? castedResponseScioglimentoUnioneCivileAtti.nomeForoAvvConiuge1
            : itemSubject?.codiceSoggetto === CodeSubject.AVVOCUC2
            ? castedResponseScioglimentoUnioneCivileAtti.nomeForoAvvConiuge2
            : undefined,
        dateCommunication:
          itemSubject?.codiceSoggetto === CodeSubject.AVVOC3
            ? castedResponseNegoziazioneAssistita.dataRicezioneAttoConiuge1
              ? DateTime.fromISO(castedResponseNegoziazioneAssistita.dataRicezioneAttoConiuge1)
              : null
            : itemSubject?.codiceSoggetto === CodeSubject.AVVOC4
            ? castedResponseNegoziazioneAssistita.dataRicezioneAttoConiuge2
              ? DateTime.fromISO(castedResponseNegoziazioneAssistita.dataRicezioneAttoConiuge2)
              : null
            : undefined,
        protocol:
          itemSubject?.codiceSoggetto === CodeSubject.AVVOC3
            ? castedResponseNegoziazioneAssistita.protocolloAttoConiuge1
            : itemSubject?.codiceSoggetto === CodeSubject.AVVOC4
            ? castedResponseNegoziazioneAssistita.protocolloAttoConiuge2
            : undefined,
        isRecognizedGroom:
          itemSubject.codiceFiscale === CodeSubject.FIGLIO
            ? castedResponseDatiEventoRiconoscimento.flagRiconosciutoDalPadre === '1'
            : undefined,
        isRecognizedWife:
          itemSubject.codiceFiscale === CodeSubject.FIGLIO
            ? castedResponseDatiEventoRiconoscimento.flagRiconosciutoDallaMadre === '1'
            : undefined,
        isChangeSurnameName:
          itemSubject.codiceSoggetto === CodeSubject.INTEST1
            ? castedResponseTrascrizioneCittadinanza.flagCambioGeneralita === '1'
            : false,
        formatBirthDate: itemSubject.idFormatoData
          ? {
              id: itemSubject.idFormatoData,
              value: itemSubject.descrizioneFormatoData || '',
            }
          : undefined,
        age: itemSubject.numeroAnni || undefined,
        // currentFiglio
        newSurname: currentFiglio?.nuovoCognome || '',
        typeAct: Boolean(currentFiglio?.idAnsc)
          ? CodeTypeAct.attoDigitale
          : CodeTypeAct.attoCartaceo,
        idActDigital: currentFiglio?.idAnsc || '',
        idActPaper: currentFiglio?.idAttoCartaceo || '',
        italianAct: currentFiglio?.idComuneRegistrazione
          ? {
              municipality: {
                description: currentFiglio.nomeComuneRegistrazione || '',
                code: currentFiglio.idComuneRegistrazione,
                idProvince: currentFiglio.idProvinciaRegistrazione,
                province: currentFiglio.siglaProvinciaRegistrazione,
              },
            }
          : undefined,
      },
      idDatiEventoRiconoscimento:
        itemSubject.codiceFiscale === CodeSubject.FIGLIO
          ? castedResponseDatiEventoRiconoscimento.key?.idDatiEventoRiconoscimento
          : undefined,
    } as ParentVM;
  });

  return res;
};
